import styled from 'styled-components';

export const MainTabSection = styled.section`
   background: #DDF5F6;
   padding:50px 0;
       @media screen and (max-width:991px) {
               margin-top: 150px;
       }
    @media screen and (max-width:1199px) {
         margin-top: 100px;
    }
   .nav-tabs{
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 20px 20px #0000001A;
        border-radius: 15px;
        padding: 6px; 
        justify-content: space-between;
        margin-bottom: 37px;
      .nav-item{ 
        &:last-child{ 
            .nav-link{
                 &:after{
                      display:none;
                      }
                  
              }

            }
            .nav-link{
                color: #01606F;
                font-family: "Jost", sans-serif;
                font-size:16px;
                font-weight: 500;
                line-height: 23px;
                padding: 13px 10px;
                border: none;
                border-radius: 10px;
                    position: relative;
                   &:after{
                   position: absolute;
                    width: 1px;
                    height: 46px;
                    content: "";
                    background:#01606F;
                    right: 0;
                    top: 0;}
                   
           &.active,&:hover{
                background: #01606F 0% 0% no-repeat padding-box;
                color:#fff;
               } 
            }
       }
   }


 
   @media (max-width: 991px) {
    .responsive-tabs {
      flex-wrap: nowrap;
      overflow-y: hidden;
       &::-webkit-scrollbar {
        height: 1px;
      }
      
     &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px #fff;
      }
      
      &::-webkit-scrollbar-thumb {
        background-color: #01606F;
        outline: 1px solid #01606F;
      }
    }
  
    .responsive-tabs .nav-link {
      width: 181px;
      padding: 10px 10px;
    }
  }
`;
